import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_fatal_error.js";
//#region src/bite_log_fatal_error_helper.ts
var bite_log_fatal_error_helper_exports = /* @__PURE__ */ __exportAll({
	name: () => name,
	stringFromEnum: () => stringFromEnum
});
function name(event) {
	switch (event) {
		case 0: return "DEVICE OK";
		case 21: return "no-internet-connection";
		case 22: return "scanner-disconnected";
		case 24: return "scale-disconnected";
		case 25: return "scanner-missing";
		case 26: return "scale-missing";
		case 32: return "kitchen-printer-missing";
		case 4: return "kitchen-printer-disconnected";
		case 5: return "kitchen-printer-no-paper";
		case 6: return "kitchen-printer-cover-open";
		case 10: return "kitchen-printer-consecutive-failed-jobs";
		case 31: return "receipt-printer-missing";
		case 12: return "receipt-printer-disconnected";
		case 13: return "receipt-printer-consecutive-failed-jobs";
		case 14: return "receipt-printer-no-paper";
		case 15: return "receipt-printer-cover-open";
		case 19: return "payment-terminal-updating";
		case 20: return "payment-terminal-disconnected";
		case 27: return "payment-terminal-missing";
		case 80: return "peripheral-kds-disconnected";
		case 81: return "peripheral-lrs-table-tracker-disconnected";
		case 82: return "peripheral-msr-disconnected";
		case 83: return "peripheral-touch-display-disconnected";
		case 50: return "menu-data-missing";
		case 51: return "users-data-missing";
		case 61: return "script-missing";
		case 62: return "image-missing";
		case 63: return "webview-not-ready";
		case 100: return "unstarted";
		case 70: return "kiosk-error";
	}
}
function stringFromEnum(event) {
	switch (event) {
		case 0: return "none";
		case 21: return "reachability-down";
		case 32: return "kitchen-printer-missing";
		case 4: return "kitchen-printer-disconnected";
		case 5: return "kitchen-printer-no-paper";
		case 6: return "kitchen-printer-cover-open";
		case 10: return "kitchen-printer-consecutive-failed-jobs";
		case 31: return "receipt-printer-missing";
		case 12: return "receipt-printer-disconnected";
		case 14: return "receipt-printer-no-paper";
		case 15: return "receipt-printer-cover-open";
		case 13: return "receipt-printer-consecutive-failed-jobs";
		case 27: return "payment-terminal-missing";
		case 20: return "payment-terminal-disconnected";
		case 19: return "payment-terminal-updating";
		case 80: return "peripheral-kds-disconnected";
		case 81: return "peripheral-lrs-table-tracker-disconnected";
		case 82: return "peripheral-msr-disconnected";
		case 83: return "peripheral-touch-display-disconnected";
		case 50: return "menu-data-missing";
		case 51: return "user-data-missing";
		case 61: return "script-missing";
		case 62: return "image-missing";
		case 63: return "webview-not-ready";
		case 100: return "unstarted";
		case 70: return "kiosk-error";
		case 22: return "scanner-disconnected";
		case 24: return "scale-disconnected";
		case 25: return "scanner-missing";
		case 26: return "scale-missing";
	}
}
//#endregion
export { bite_log_fatal_error_helper_exports, name, stringFromEnum };

//# sourceMappingURL=bite_log_fatal_error_helper.js.map